import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  TemplateRef,
  ViewChild,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { AppTableComponent } from '../../../../../shared/components/table/app-table.component';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { OffcanvasService } from '../../../../../_services/offcanvas-service/offcanvas.service';
import { TransactionsApiService } from '../../../../../_services/transactions-service/transactions-api.service';
import { TableColumn } from '@swimlane/ngx-datatable';
import { HttpParams } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs';
import { depositTableColumns } from '../_utils/transactions-utils';
import { PaginatedResults } from '@bo/ng-api';
import { Transaction } from '../../../../../_interfaces/transactions.interface';
import {
  StatusBadgeComponent,
  statusBadgeDepartments,
} from '../../../../../shared/components/status-badge/status-badge.component';
import { EmptyIndicatorPipe } from '../../../../../shared/pipes/empty-indicator.pipe';

@Component({
  selector: 'app-deposits',
  imports: [AppTableComponent, CurrencyPipe, DatePipe, StatusBadgeComponent, EmptyIndicatorPipe],
  templateUrl: './deposits.component.html',
})
export class DepositsComponent implements OnInit, AfterViewInit, OnDestroy {
  readonly offcanvasService = inject(OffcanvasService);
  readonly transactionsApiService = inject(TransactionsApiService);
  readonly route = inject(ActivatedRoute);
  readonly router = inject(Router);

  protected columns: Array<TableColumn> = [];
  queryParams = new HttpParams();
  params: Params | undefined;
  readonly subscriptions = new Subscription();
  private readonly columnsInitialized = signal(false);

  // Forwarded to the nested app-table to suppress fetches while the parent
  // is navigating between the Payments/Deposits tabs. See AppTableComponent.
  @Input() suppressFetch: boolean = false;

  /* eslint-disable @typescript-eslint/no-explicit-any */
  // TODO: TemplateRef<any> can be fixed by refactoring the @bo/ng-datatable library.
  @ViewChild('dateCell') dateCell!: TemplateRef<any>;
  @ViewChild('descriptionCell') descriptionCell!: TemplateRef<any>;
  @ViewChild('amountCell') amountCell!: TemplateRef<any>;
  @ViewChild('statusCell') statusCell!: TemplateRef<any>;
  /* eslint-enable @typescript-eslint/no-explicit-any */

  ngOnInit() {
    this.columns = depositTableColumns;
  }

  ngAfterViewInit() {
    this.setupColumns();
  }

  private setupColumns(): void {
    if (this.columnsInitialized()) return;

    for (const column of this.columns) {
      if (column.prop === 'timestamp') column.cellTemplate = this.dateCell;
      if (column.prop === 'description') column.cellTemplate = this.descriptionCell;
      if (column.prop === 'amount') column.cellTemplate = this.amountCell;
      if (column.prop === 'status') column.cellTemplate = this.statusCell;
    }

    // Reassign array to trigger change detection in the table
    this.columns = [...this.columns];
    this.columnsInitialized.set(true);
  }

  getData(queryParams: HttpParams): Observable<PaginatedResults<Transaction>> {
    return this.transactionsApiService.getTransactions(queryParams);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  protected readonly statusBadgeDepartments = statusBadgeDepartments;
}
